import React, { useEffect, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import StoryImg from "../../assets/Section/stories.png";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import ArrowNew from "../../assets/Common/send.png";

// import required modules
import { Pagination } from 'swiper/modules';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { X } from 'react-bootstrap-icons';
import { isMobile } from 'react-device-detect';

export default function StoriesCarousel({data, colors}) {
  // Function to handle scrolling to the specific section
  const [open, setOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    const headerOffset = 100; // Adjust based on the header height
    const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      const bullet = '<span class="' + className + '">' + (index + 1) + '</span>';
      // Append the button only after the last bullet
      if (index === data?.length - 1) {
        return bullet + 
          `<span class="custom-insurance-button max-sm:mt-5 ml-2 inline-flex cursor-pointer border text-[#fff] my-auto py-1.5 px-4 text-sm not-italic font-semibold shadow-sm rounded-[49px] border-solid border-[#F0F0F0] gap-2" style="background-color: ${colors?.secondary}">` +
          `Let's Discuss` + 
          '<img src="' + ArrowNew + '" alt="arrow" />' +
          '</span>';
      }
      return bullet;
    },
  };

  useEffect(() => {
    // Attach the onClick event to the custom button after the Swiper renders the pagination
    const button = document.querySelector('.custom-insurance-button');
    if (button) {
      button.addEventListener('click', () => scrollToSection('section6'));
    }

    // Clean up event listener when component unmounts
    return () => {
      if (button) {
        button.removeEventListener('click', () => scrollToSection('section6'));
      }
    };
  }, [data?.length]);

  useEffect(() => {
    // Add dynamic styles for Swiper pagination
    const style = document.createElement('style');
    style.textContent = `
      .swiper-pagination-bullet-active {
        color: #fff !important;
        background: ${colors?.primary} !important;
      }
    `;
    document.head.appendChild(style);

    // Cleanup
    return () => {
      document.head.removeChild(style);
    };
  }, [colors?.primary]);

  return (
    <div className='py-4 pb-16 lg:max-w-7xl mx-auto story'>
      <Swiper
        pagination={pagination}
        modules={[Pagination]}
        className="mySwiper"
      >
        {data?.map((story, index) => (
          <SwiperSlide key={index}>
            <div className='flex max-sm:block max-sm:space-y-8 justify-center px-12 max-sm:px-0'>
              <div className='px-8 max-sm:w-full'>
                <img className='h-[350px] mx-auto w-[350px]' src={story?.image} alt='' />
              </div>
              <div className='w-[60%] max-sm:w-full px-8 space-y-4 text-left'>
                <p 
                  style={{ color: colors?.primary }}
                  className='text-5xl max-sm:text-3xl not-italic font-bold leading-[120%]'
                >
                  Our Success Stories
                </p>
                <p 
                  style={{ color: colors?.textMuted }}
                  className='max-sm:text-base text-lg not-italic font-normal leading-[132%]'
                >
                  {story?.message?.slice(0, isMobile ? 250:580)}
                  {story?.message?.length > (isMobile ? 250 : 580) ? (
                    <>
                      <span>...</span>
                      <span 
                        onClick={() => { setPopupData(story); setOpen(true); }} 
                        style={{ color: colors?.primary }}
                        className='cursor-pointer text-base hover:underline'
                      >
                        read more
                      </span>
                    </>
                  ) : ""}
                </p>
                <p 
                  style={{ color: colors?.primary }}
                  className='max-sm:text-sm font-medium'
                >
                  - {story?.name}, {story?.designation}, {story?.company}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <Transition show={open}>
        <Dialog className="relative z-10" onClose={setOpen}>
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-[#fefefe] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">
                  <div className='bg-no-repeat p-8'>
                    <X 
                      className="absolute right-2 top-2 z-50 cursor-pointer text-2xl" 
                      style={{ color: colors?.textMuted }}
                      onClick={() => setOpen(false)} 
                    />
                    <div className='space-y-2 mb-4'>
                      <div className='flex justify-center mx-auto w-32 h-32'>
                        <img 
                          className='rounded-lg object-center w-full h-full' 
                          src={popupData?.image} 
                          alt="No content available" 
                        />
                      </div>
                    </div>
                    <div className='space-y-8 font-[HelveticaNeueLTStd] mb-4 text-sm text-[#222]'>
                      {popupData?.message}
                    </div>
                    <p className='w-ful font-[TATAAIARegularPrint] font-semibold text-left text-[10px]'>
                      - {popupData?.name}, {popupData?.designation}, {popupData?.company}
                    </p>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
